'use strict';

angular.module('shiftTraderApp', ['ngResource','ngCookies','angularLocalStorage','angularytics','angular-flash.service',
                'angular-flash.flash-alert-directive','shoppinpal.mobile-menu','shiftTraderApp.filters', 'autofill-directive',
                'ui.router', 'ngAnimate', 'saTemplates', 'ui.bootstrap', 'ngTouch', 'uuid4', 'ngSanitize', 'angular-confirm', 'angucomplete-alt', 'RecursionHelper', 'shiftTraderApp.constants'])
  .config(['$provide', '$stateProvider', '$urlRouterProvider', 'AngularyticsProvider', '$compileProvider', '$logProvider', function ($provide, $stateProvider, $urlRouterProvider, AngularyticsProvider, $compileProvider, $logProvider) {
    AngularyticsProvider.setEventHandlers(['Console', 'GoogleUniversal']);

    $logProvider.debugEnabled(true);

    $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|tel|sms|mms):/);

    $provide.decorator('$exceptionHandler', ['$delegate', '$injector', 'EventTrackingService', function($delegate, $injector, EventTrackingService) {
      return function (exception, cause) {
        $delegate(exception, cause);
        console.log(exception);

        var $modalStack = $injector.get('$modalStack');
        var Session = $injector.get('Session');
        var $location = $injector.get('$location');

        var context = {};
        context.events = EventTrackingService.getEvents(10);
        if ($modalStack.getTop()) {
          context.topModal = {
            templateUrl: $modalStack.getTop().windowTemplateUrl,
            windowClass: $modalStack.getTop().windowClass
          };
        }

        context.path = $location.path();
        context.url = $location.url();
        context.absUrl = $location.absUrl();

        context.isLoggedIn = Session.isLoggedIn().toString();
        var userData = {};
        if (Session.isLoggedIn() && Session.me) {
          userData.id = Session.me.id;
          userData.username = Session.me.name;
          userData.email = Session.me.email;
          context.orgId = Session.getCurrentOrgId();

          if (context.orgId) {
            var memb = _.find(Session.me.memberships, {organization_id: context.orgId});
            if (memb) {
              context.orgName = memb.organization.name;
            }
          }

          Rollbar.configure({payload: {person: userData}});
        }

        var codeId = $('span#before_dist_script_load+script');
        if (codeId && codeId.length > 0) {
          codeId = codeId.attr('src');
          Rollbar.configure({payload: {code_id: codeId}});
        }

        Rollbar.error(exception, {payload: context});
      };
    }]);

    $urlRouterProvider
      .otherwise('/enter')
      .when('/employeeSchedule', '/employeeSchedule/me')
      .when('/profile', '/profile/me');

    $stateProvider
      .state('enter', {
        url: '/enter',
        template: '',
        resolve: {
          neverresolve: ['Session', '$state', '$stateParams', '$location', '$q', '$timeout', function(Session, $state, $stateParams, $location, $q, $timeout) {
            var qs;
            /* jshint ignore:start */
            qs = (function(a) {
              if (a == "") {return {};}
              var b = {};
              for (var i = 0; i < a.length; ++i) {
                var p=a[i].split('=');
                if (p.length !== 2) { continue; }
                b[p[0]] = decodeURIComponent(p[1].replace(/\+/g, " "));
              }
              return b;
            })(window.location.search.substr(1).split('&'));
            /* jshint ignore:end */

            if (_.has($stateParams, 'activationCode')) {
              Session.clearSession();
              $location.path('activateUser/' + $stateParams.activationCode);
            } else if (_.has(qs, 'activationCode')) {
              Session.clearSession();
              $location.path('activateUser/' + qs.activationCode);
            } else if (_.has($stateParams, 'resetCode')) {
              Session.clearSession();
              $location.path('resetPassword/' + $stateParams.resetCode);
            } else if (_.has(qs, 'resetCode')) {
              Session.clearSession();
              $location.path('resetPassword/' + qs.resetCode);
            } else {
              if (Session.isLoggedIn()) {
                $timeout(function() {
                  $state.go('home');
                }, 0);
              } else {
                $timeout(function() {
                  $state.go('login');
                }, 0);
              }
            }

            return $q.resolve();
          }]
        }
      })
      .state('login', {
        url: '/login',
        templateUrl: 'views/login.html',
        controller: 'LoginCtrl',
        resolve: {
          loginCheck: ['Session', '$state', '$q', '$timeout', function(Session, $state, $q, $timeout) {
            if (Session.isLoggedIn()) {
              $timeout(function() {
                $state.go('home');
              }, 0);
            }

            return $q.resolve(true);
          }]
        }
      })
      .state('home', {
        url: '/home',
        templateUrl: 'views/home.html',
        controller: 'HomeCtrl',
        resolve: {
          me: ['Users', function (Users) {
            return Users.whoAmI();
          }],
          userAvailabilityChangeRequests: ['UserAvailabilityChangeRequests', function(UserAvailabilityChangeRequests) {
            return UserAvailabilityChangeRequests.getAll({userId: 'me'});
          }]
        },
        onEnter: ['$rootScope', function($rootScope) {
          $rootScope.$broadcast('setTopNavTitle', 'Home');
        }]
      })
      .state('menu', {
        url: '/menu',
        templateUrl: 'views/menu.html',
        controller: ['$scope', 'Users', 'UserPermissionsService', function($scope, Users, UserPermissionsService) {
          $scope.state = {
            meFailed: false
          };

          $scope.me = null;

          Users.whoAmI()
            .then(function(me) {
              $scope.me = me;

              UserPermissionsService.can('ui.days_off.view_management', 'current')
                .then(function(res) {
                  $scope.state.canViewRequestsPage = res;
                });
            }, function() {
              $scope.state.meFailed = true;
            });
        }],
        resolve: {
          me: ['Users', function (Users) {
            return Users.whoAmI();
          }]
        },
        onEnter: ['$rootScope', function($rootScope) {
          $rootScope.$broadcast('setTopNavTitle', 'Menu');
        }]
      })
      .state('messages', {
        url: '/messages',
        templateUrl: 'views/messages.html',
        controller: 'MessagesCtrl',
        resolve: {
          me: ['Users', function (Users) {
            return Users.whoAmI();
          }],
          notifications: ['Notifications', 'me', function (Notifications, me) {
            return Notifications.getNewNotifications();
          }]
        },
        onEnter: ['$rootScope', function($rootScope) {
          $rootScope.$broadcast('setTopNavTitle', 'Notifications');
        }]
      })
      .state('trades', {
        abstract: true,
        template: '<div ui-view></div>',
        url: '/trades',
        resolve: {
          me: ['Users', function (Users) {
            return Users.whoAmI();
          }],
          org: ['Session', function (Session) {
            return Session.getCurrentOrg();
          }]
        }
      })
      .state('trades.list', {
        templateUrl: 'views/trades.html',
        controller: 'TradesCtrl',
        url: '',
        resolve: {
          trades: ['$q', 'ShiftTradesResource', 'Users', 'Session', 'me', function ($q, ShiftTradesResource, Users, Session, me) {
            var defer = $q.defer();
            ShiftTradesResource.query({user_id: 'me', active: true}, defer.resolve);
            return defer.promise;
          }]
        },
        onEnter: ['$rootScope', function($rootScope) {
          $rootScope.$broadcast('setTopNavTitle', 'My Trades');
        }]
      })
      .state('trades.show', {
        url: '/:tradeId',
        templateUrl: 'views/trade.html',
        controller: 'TradeCtrl',
        resolve: {
          trade: ['ShiftTradesResource', '$stateParams', '$q', 'me', function (ShiftTradesResource, $stateParams, $q, me) {
            var defer = $q.defer();
            ShiftTradesResource.get({id: $stateParams.tradeId}, defer.resolve);
            return defer.promise;
          }],
          me: ['Users', function (Users) {
            return Users.whoAmI();
          }]
        },
        onEnter: ['$rootScope', function($rootScope) {
          $rootScope.$broadcast('setTopNavTitle', 'Trade');
        }]
      })
      .state('pickups', {
        url: '/pickups',
        templateUrl: 'views/pickups.html',
        controller: 'PickupsCtrl',
        resolve: {
          trades: ['ShiftTradesResource', '$q', 'me', function(ShiftTradesResource, $q, me) {
            var defer = $q.defer();
            ShiftTradesResource.query({active: true}, defer.resolve);
            return defer.promise;
          }],
          me: ['Users', function (Users) {
            return Users.whoAmI();
          }]
        },
        onEnter: ['$rootScope', function($rootScope) {
          $rootScope.$broadcast('setTopNavTitle', 'Pickups');
        }]
      })
      .state('profile', {
        abstract: true,
        url: '/profile/:userId',
        template: '<div ui-view></div>',
        resolve: {
          positions:['Positions', 'Session', function(Positions, Session) {
            return Positions.getAllInOrg(Session.getCurrentOrgId());
          }],
          me: ['Users', function (Users) {
            return Users.whoAmI();
          }],
          user: ['Users', '$stateParams', function (Users, $stateParams) {
            return Users.getById($stateParams.userId);
          }]
        },
        onEnter: ['$rootScope', function($rootScope) {
          $rootScope.$broadcast('setTopNavTitle', 'Profile');
        }]
      })
      .state('profile.main', {
        url: '',
        templateUrl: 'views/profile.html',
        controller: 'ProfileCtrl',
        onEnter: ['$rootScope', function($rootScope) {
          $rootScope.$broadcast('setTopNavTitle', 'Profile');
        }]
      })
      .state('profile.availability', {
        abstract: true,
        url: '/availability',
        template: '<div ui-view=""/>',
        resolve: {
          user: ['Users', '$stateParams', function (Users, $stateParams) {
            return Users.getById($stateParams.userId);
          }],
          userAvailabilityChangeRequests: ['UserAvailabilityChangeRequests', '$stateParams', function(UserAvailabilityChangeRequests, $stateParams) {
            return UserAvailabilityChangeRequests.getAll({user_id: $stateParams.userId});
          }],
          pending_in_review_availability_sets: ['AvailabilitySets', '$stateParams', function(AvailabilitySets, $stateParams) {
            return AvailabilitySets.getUserPendingAndInReviewSets($stateParams.userId);
          }]
        }
      })
      .state('profile.availability.main', {
        url: '',
        templateUrl: 'views/profile.availability.html',
        controller: 'ProfileAvailabilityCtrl',
        resolve: {
        },
        onEnter: ['$rootScope', 'me', 'user', function($rootScope, me, user) {
          if (me.id === user.id) {
            $rootScope.$broadcast('setTopNavTitle', 'My Availability');
          } else {
            $rootScope.$broadcast('setTopNavTitle', user.first_name + '\'s Availability');
          }
        }]
      })
      .state('profile.daysOff', {
        abstract: true,
        url: '/daysOff',
        template: '<div ui-view=""/>',
        resolve: {
          user: ['Users', '$stateParams', function (Users, $stateParams) {
            return Users.getById($stateParams.userId);
          }],
          me: ['Users', function (Users) {
            return Users.whoAmI();
          }]
        }
      })
      .state('profile.daysOff.overview', {
        url: '',
        templateUrl: 'views/daysOff/daysOffOverview.html',
        controller: 'DaysOffOverviewCtrl',
        resolve: {
          activeDaysOff: ['AvailabilityRules', '$stateParams', 'me', function(AvailabilityRules, $stateParams, me) {
            return AvailabilityRules.getAll({
              type: 'daysoff',
              active: true,
              status: 'any',
              user_id: $stateParams.userId,
              start_date: moment.utc().subtract(3, 'months').format('YYYY-MM-DD')
            });
          }]
        },
        onEnter: ['$rootScope', function($rootScope) {
          $rootScope.$broadcast('setTopNavTitle', 'Days Off Overview');
        }]
      })
      .state('profile.daysOff.history', {
        url: '/history',
        templateUrl: 'views/daysOff/daysOffHistory.html',
        controller: 'DaysOffHistoryCtrl',
        resolve: {
          activeDaysOff: ['AvailabilityRules', '$stateParams', 'me', function(AvailabilityRules, $stateParams, me) {
            return AvailabilityRules.getAll({
              type: 'daysoff',
              active: true,
              status: 'any',
              user_id: $stateParams.userId,
              start_date: moment.utc().subtract(3, 'months').format('YYYY-MM-DD')
            });
          }],
          inactiveDaysOff: ['AvailabilityRules', '$stateParams', 'me', function(AvailabilityRules, $stateParams, me) {
            return AvailabilityRules.getAll({
              type: 'daysoff',
              active: false,
              status: 'any',
              user_id: $stateParams.userId,
              start_date: moment.utc().subtract(3, 'months').format('YYYY-MM-DD')
            });
          }]
        },
        onEnter: ['$rootScope', function($rootScope) {
          $rootScope.$broadcast('setTopNavTitle', 'Days Off');
        }]
      })
      .state('profile.daysOff.new', {
        url: '/new',
        templateUrl: 'views/daysOff/newDayOffRequest.html',
        controller: 'NewDayOffRequestCtrl',
        onEnter: ['$rootScope', function($rootScope) {
          $rootScope.$broadcast('setTopNavTitle', 'Request Off');
        }]
      })
      .state('profile.daysOff.create', {
        url: '/create',
        templateUrl: 'views/daysOff/createDayOffRequest.html',
        controller: 'CreateDayOffRequestCtrl',
        onEnter: ['$rootScope', function($rootScope) {
          $rootScope.$broadcast('setTopNavTitle', 'Request Off');
        }]
      })
      .state('profile.daysOff.show', {
        url: '/:dayOffId',
        templateUrl: 'views/daysOff/showDayOffRequest.html',
        controller: 'ShowDayOffCtrl',
        resolve: {
          dayOff: ['AvailabilityRules', '$stateParams', 'me', function(AvailabilityRules, $stateParams, me) {
            return AvailabilityRules.getById($stateParams.dayOffId);
          }]
        },
        onEnter: ['$rootScope', function($rootScope) {
          $rootScope.$broadcast('setTopNavTitle', 'Day Off');
        }]
      })
      .state('requests', {
        url: '/requests',
        templateUrl: 'views/requests.html',
        controller: 'RequestsCtrl',
        resolve: {
          trades: ['ShiftTradesResource', '$q', 'me', function(ShiftTradesResource, $q, me) {
            var defer = $q.defer();
            ShiftTradesResource.query({active: true}, defer.resolve);
            return defer.promise;
          }],
          me: ['Users', function (Users) {
            return Users.whoAmI();
          }],
          daysOffRequests: ['AvailabilityRules', 'me', function(AvailabilityRules, me) {
            return AvailabilityRules.getAllDaysOffNeedingApproval();
          }]
        },
        onEnter: ['$rootScope', function($rootScope) {
          $rootScope.$broadcast('setTopNavTitle', 'Requests');
        }]
      })
      .state('storeSchedule', {
        abstract: true,
        url: '/storeSchedule',
        template: '<div ui-view></div>',
        resolve: {
          me: ['Users', function (Users) {
            return Users.whoAmI();
          }],
          allPositions: ['Positions', function(Positions) {
            return Positions.getAllInOrg();
          }],
          org: ['Session', function (Session) {
            return Session.getCurrentOrg();
          }]
        }
      })
      .state('storeSchedule.show', {
        url: '/:date',
        templateUrl: 'views/storeSchedule.html',
        controller: 'StoreScheduleCtrl',
        resolve: {
          workPeriods: ['WorkPeriods', '$stateParams', 'TimeService', 'me', 'org', function(WorkPeriods, $stateParams, TimeService, me, org) {
            var tempDate = TimeService.getBeginningOfDayFromDate(moment($stateParams.date));
            if (!tempDate.isValid()) {
              tempDate = TimeService.getBeginningOfDayFromDate(moment.utc());
            }
            var data = {
              start_time: tempDate.toISOString(),
              end_time: moment(tempDate).add(1, 'days').toISOString()
            };

            if (!_.isNull($stateParams.orgId)) {
              data.organization_id = $stateParams.orgId;
            }

            return WorkPeriods.getAll(data);
          }],
          theDate: ['$stateParams', 'TimeService', 'me', 'org', function($stateParams, TimeService, me, org) {
            var tempDate = TimeService.getBeginningOfDayFromDate(moment($stateParams.date));
            if (tempDate.isValid()) {
              return tempDate;
            } else {
              return TimeService.getBeginningOfDayFromDate(moment.utc());
            }
          }]
        }
      })
      .state('employeeSchedule', {
        abstract: true,
        url: '/employeeSchedule',
        template: '<div ui-view></div>',
        resolve: {
          me: ['Users', function (Users) {
            return Users.whoAmI();
          }]
        }
      })
      .state('employeeSchedule.show', {
        url: '/:userId?toTrade',
        templateUrl:'views/employeeSchedule.html',
        controller:'EmployeeScheduleCtrl',
        resolve: {
          upcomingWorkPeriods: ['WorkPeriods', 'Users', 'Session', '$stateParams', 'me', function(WorkPeriods, Users, Session, $stateParams, me) {
            //console.log($stateParams);
            return WorkPeriods.getByUserId($stateParams.userId, {
              start_time: moment.utc().subtract(12, 'hours').toISOString()
            });
          }],
          selectedUser: ['$stateParams', 'Users', '$rootScope', '$q', function($stateParams, Users, $rootScope, $q) {
            var deferred = $q.defer();
            if ($stateParams.userId === 'me') {
              $rootScope.$broadcast('setTopNavTitle', 'My Schedule');
              deferred.resolve([]);
            } else {
              Users.getById($stateParams.userId).then(function(u) {
                $rootScope.$broadcast('setTopNavTitle', u.first_name + '\'s Schedule');
                deferred.resolve([u]);
              }, function(response) {
                deferred.reject(response);
              });
            }

            return deferred.promise;
          }]
        }
      })
      .state('feedback', {
        url: '/feedback',
        templateUrl:'views/feedback.html',
        controller: ['$scope', 'Session', function($scope, Session) {
          $('.org_id_input').val(Session.getCurrentOrgId());
          $('.user_id_input').val(Session.getCurrentUserId());
          if (Session.me && Session.me.id) {
            $('.memb_role_input').val(Session.me.memberships[0].role);
          }
        }],
        resolve: {
          setTitle: ['$rootScope', function($rootScope) {
            $rootScope.$broadcast('setTopNavTitle', 'Feedback');
          }]
        }
      })

      .state('terms', {
        url: '/terms',
        templateUrl:'views/terms.html',
        onEnter: ['$rootScope', function($rootScope) {
            $rootScope.$broadcast('setTopNavTitle', 'Terms and Conditions');
          }]
      })
      .state('thankyou', { // You're welcome. :]
        url: '/thankyou',
        templateUrl:'views/thankyou.html',
        onEnter: ['$rootScope', function($rootScope) {
            $rootScope.$broadcast('setTopNavTitle', 'Thank You,');
          }]
      })
      .state('workPeriods', {
        url: '/workPeriods',
        abstract: true,
        template: '<div ui-view></div>',
        resolve: {
          me: ['Users', function (Users) {
            return Users.whoAmI();
          }]
        }
      })
      .state('workPeriods.show', {
        url: '/:workPeriodId',
        templateUrl:'views/WorkPeriod.html',
        controller:'WorkPeriodCtrl',
        resolve: {
          workPeriod: ['$stateParams', 'WorkPeriods', 'me', function($stateParams, WorkPeriods, me) {
            return WorkPeriods.getById($stateParams.workPeriodId);
          }]
        }
      })
      .state('workingToday', {
        url: '/workingToday',
        templateUrl:'views/workingToday.html',
        controller:'WorkingTodayCtrl',
        resolve: {
          me: ['Users', function(Users) {
            return Users.whoAmI();
          }],
          workPeriods: ['$stateParams', 'WorkPeriods', 'Session', 'me', function($stateParams, WorkPeriods, Session, me) {
            var times = {
              start_time: moment.utc().tz(Session.getTimezone()).hours(0).minutes(0).seconds(0).milliseconds(0).subtract('days', 1).toISOString(),
              end_time: moment.utc().tz(Session.getTimezone()).hours(0).minutes(0).seconds(0).milliseconds(0).add('hours', 36).toISOString()
            };
            return WorkPeriods.getAll(times);
          }]
        }
      })
      .state('setupTrade', {
        url: '/setupTrade/:workPeriodId',
        templateUrl: 'views/setupTrade.html',
        controller: 'SetupTradeCtrl',
        resolve: {
          me: ['Users', function(Users) {
            return Users.whoAmI();
          }],
          workPeriod: ['$stateParams', 'WorkPeriods', 'me', function($stateParams, WorkPeriods, me) {
            return WorkPeriods.getById($stateParams.workPeriodId);
          }],
          mode: function() {
            return 'trade';
          }
        }
      })
      .state('createTrade', {
        abstract: true,
        url: '/createTrade',
        template: '<div ui-view></div>',
        resolve: {
          me: ['Users', function(Users) {
            return Users.whoAmI();
          }]
        }
      })
      .state('createTrade.giveaway', {
        url: '/:workPeriodId',
        templateUrl: 'views/createTrade.html',
        controller: 'CreateTradeCtrl',
        resolve: {
          workPeriod: ['$stateParams', 'WorkPeriods', 'me', function($stateParams, WorkPeriods, me) {
            return WorkPeriods.getById($stateParams.workPeriodId);
          }],
          tradeWorkPeriod: function() {
            return [];
          },
          mode: function() {
            return 'giveaway';
          }
        }
      })
      .state('createTrade.trade', {
        url: '/:workPeriodId/:tradeWorkPeriodId',
        templateUrl: 'views/createTrade.html',
        controller: 'CreateTradeCtrl',
        resolve: {
          workPeriod: ['$stateParams', 'WorkPeriods', 'me', function($stateParams, WorkPeriods, me) {
            return WorkPeriods.getById($stateParams.workPeriodId);
          }],
          tradeWorkPeriod: ['$stateParams', 'WorkPeriods', 'me', function($stateParams, WorkPeriods, me) {
            return WorkPeriods.getById($stateParams.tradeWorkPeriodId);
          }],
          mode: function() {
            return 'trade';
          }
        }
      })
      .state('employees', {
        url: '/employees?positionId',
        templateUrl: 'views/employees.html',
        controller: 'EmployeesCtrl',
        resolve: {
          users: ['Users', function (Users) {
            return Users.getAll({view: 'med'});
          }],
          me: ['Users', function(Users) {
            return Users.whoAmI();
          }],
          positions: ['Positions', function(Positions) {
            return Positions.getAllInOrg();
          }],
          org: ['Session', function (Session) {
            return Session.getCurrentOrg();
          }]
        },
        onEnter: ['$rootScope', function($rootScope) {
          $rootScope.$broadcast('setTopNavTitle', 'Employee Roster');
        }]
      })
      .state('storeAnnouncements', {
        abstract: true,
        url: '/storeAnnouncements',
        template: '<div ui-view></div>',
        resolve: {
          me: ['Users', function (Users) {
            return Users.whoAmI();
          }],
          allPositions: ['Positions', function(Positions) {
            return Positions.getAllInOrg();
          }],
          org: ['Session', function (Session) {
            return Session.getCurrentOrg();
          }]
        }
      })
      .state('storeAnnouncements.list', {
        url: '',
        templateUrl: 'views/organizationMessages.list.html',
        controller: 'OrganizationMessagesListCtrl',
        resolve: {
          currentOrgMessages: ['OrganizationMessages', 'Session', 'me', function(OrganizationMessages, Session, me) {
            return OrganizationMessages.getCurrentOrganizationMessages(Session.getCurrentOrgId());
          }]
        },
        onEnter: ['$rootScope', function($rootScope) {
          $rootScope.$broadcast('setTopNavTitle', 'Store News');
        }]
      })
      .state('storeAnnouncements.new', {
        url: '/new',
        templateUrl: 'views/organizationMessage.new.html',
        controller: 'OrganizationMessageNewCtrl',
        onEnter: ['$rootScope', function($rootScope) {
          $rootScope.$broadcast('setTopNavTitle', 'Write New Message');
        }]
      })
      .state('storeAnnouncements.show', {
        url: '/:id',
        templateUrl: 'views/organizationMessage.show.html',
        controller: 'OrganizationMessageShowCtrl',
        resolve: {
          orgMessage: ['OrganizationMessages', '$stateParams', 'me', function(OrganizationMessages, $stateParams, me) {
            return OrganizationMessages.getMessageById($stateParams.id);
          }]
        },
        onEnter: ['$rootScope', function($rootScope) {
          $rootScope.$broadcast('setTopNavTitle', 'Store Announcement');
        }]
      })
      .state('notes', {
        abstract: true,
        url: '/notes',
        template: '<div ui-view></div>'
      })
      .state('notes.show', {
        url: '/:id',
        templateUrl: 'views/notes.show.html',
        controller: 'NotesShowCtrl',
        resolve: {
          note: ['$stateParams', 'NotesStore', function($stateParams, NotesStore) {
            return NotesStore.getByNoteId($stateParams.id);
          }]
        },
        onEnter: ['$rootScope', function($rootScope) {
          $rootScope.$broadcast('setTopNavTitle', 'View Note');
        }]
      })
      .state('resetPassword', {
        url: '/resetPassword/:resetCode',
        templateUrl: 'views/resetPassword.html',
        controller: 'ResetPasswordCtrl'
      })
      .state('activateUser', {
        url: '/activateUser/:activationCode',
        templateUrl: 'views/activateUser.html',
        controller: 'ActivateUserCtrl'
      })
      .state('setHostnameAndEnv', {
        url: '/setHostnameAndEnv/:hostname/:env',
        resolve: {
          setBackend: ['$location', '$stateParams', 'ServerUrls', 'Session',
            function($location, $stateParams, ServerUrls, Session) {
              if (ServerUrls.isHostnameDefined($location.host())) {
                $location.path('/');
              } else {
                ServerUrls.setHostname($stateParams.hostname);
                ServerUrls.setEnv($stateParams.env);
                ServerUrls.setupCurrentServer();
                Session.logout();
              }
            }]
        }
      })
      .state('clearHostnameAndEnv', {
        url: '/clearHostnameAndEnv',
        resolve:  {
          setBackend: ['$location', '$stateParams', 'ServerUrls', 'Session', function($location, $stateParams, ServerUrls, Session) {
            if (ServerUrls.isHostnameDefined($location.host())) {
              $location.path('/');
            } else {
              ServerUrls.clearHostnameAndEnv();
              Session.logout();
            }
          }]
        }
      })
      .state('logout', {
        url: '/logout',
        onEnter: ['$location', 'Session', function($location, Session) {
            Session.logout();
            $location.path('/login');
          }]
      });
  }])
    .run(['$rootScope', 'ActivityIndicatorService', 'OrganizationMessageResponses', '$modal', 'Session', '$interval', 'ClientTypeDetectionService', 'ServerUrls', 'EventTrackingService', '$confirmModalDefaults', 'flash', '$window', '$timeout', 'saHomeBackgroundEnabled',
      function($rootScope, ActivityIndicatorService, OrganizationMessageResponses, $modal, Session, $interval, ClientTypeDetectionService, ServerUrls, EventTrackingService, $confirmModalDefaults, flash, $window, $timeout, saHomeBackgroundEnabled) {
      var transactionId = null;
      var unreadMessagesModalOpen = false;
      var lastStoreAnnouncementsCheck;


      $rootScope.transitioningToRoute = {};
      $rootScope.currentRoute = {};

      $rootScope.$on('$stateChangeStart',
        function(event, toState, toParams, fromState, fromParams) {
          //console.log('$stateChangeStart', toState);
          if (toState.name !== 'login') {
            $rootScope.transitioningToRoute = {state: toState, params: toParams};
          }
          //console.log('start -- transitioningToRoute:', $rootScope.transitioningToRoute, 'currentRoute:', $rootScope.currentRoute.state);
        });

      $rootScope.$on('$stateChangeSuccess',
        function(event, toState, toParams, fromState, fromParams) {
          //console.log('$stateChangeSuccess', toState);
          if (!_.contains(['login', 'activateUser', 'resetPassword', 'enter'], toState.name)) {
            $rootScope.transitioningToRoute = false;
            $rootScope.currentRoute = {state: toState, params: toParams};
          }

          if (saHomeBackgroundEnabled) {
            if (toState.name !== 'home') {
              $('.home-screen-bg').fadeOut();
            } else if (toState.name === 'home') {
              $('.home-screen-bg').fadeIn();
            }
          }
          //console.log('success -- transitioningToRoute:', $rootScope.transitioningToRoute, 'currentRoute:', $rootScope.currentRoute.state);
        });

      $rootScope.registerForbiddenRequest = function(rejection) {

        if ($rootScope.transitioningToRoute) {
          console.log('we\'re transitioning routes', $rootScope.transitioningToRoute);
          flash.error = 'You don\'t have permission to do this.  Are you an \'active\' employee?';
          if ($window.history.length > 0) {
            $window.history.back();
          } else {
            $state.go('home');
          }
          return true;
        } else {
          return false;
        }
      };

      $rootScope.$on('$locationChangeSuccess', function (e, newUrl) {
        EventTrackingService.addEvent('locationChange', {url: newUrl});
      });

      $rootScope.$on('$stateChangeStart', function(event, data) {
        if (!_.isNull(transactionId)) {
          ActivityIndicatorService.endTransaction(transactionId);
        }
        transactionId = ActivityIndicatorService.beginTransaction(data.name);
      });

      $rootScope.$on('$stateChangeSuccess', function(event, data) {
        ActivityIndicatorService.endTransaction(transactionId);
        transactionId = null;

        if ( (_.isUndefined(lastStoreAnnouncementsCheck) || moment().isAfter(moment(lastStoreAnnouncementsCheck).add(60, 'seconds'))) &&
            (Session.isLoggedIn()) ) {
          // now let's see about getting unreadOrganizationMessages if we haven't checked in the last 60 seconds
          OrganizationMessageResponses.getMyUnacknowledgedOrganizationMessageResponses()
              .then(function(responses) {
                lastStoreAnnouncementsCheck = moment();
                $rootScope.$broadcast('sa:unreadOrganizationMessages', responses);
              }, function(response) {
                Rollbar.error('OrganizationMessageResponse.getMyUnacknowledged failed', {response: response, session: {atoken: Session.getAccessToken(), rtoken: Session.getRefreshToken() }});
            });
        }
      });

      $rootScope.$on('$stateChangeError', function(event, toState, toParams, fromState, fromParams, error) {
        ActivityIndicatorService.endTransaction(transactionId);
        transactionId = null;
      });


      $rootScope.$on('sa:unreadOrganizationMessages', function(event, messageResponses) {
        console.log('sa:unreadOrganizationMessages');
        if (!unreadMessagesModalOpen && messageResponses.length > 0) {
          unreadMessagesModalOpen = true;

          var modalInstance = $modal.open({
            windowClass: 'modal_mobile_full',
            templateUrl: 'views/organizationMessageResponseModal.html',
            controller: ['$scope', 'OrganizationMessageResponses', 'params', '$modalInstance', '$timeout', function ($scope, OrganizationMessageResponses, params, $modalInstance, $timeout) {
              $scope.messageResponses = params.messageResponses;
              $scope.close = $modalInstance.close;

              $scope.acknowledgeMessage = function (messageResp) {
                messageResp.$sendAcknowledgement()
                    .then(function (response) {
                      $scope.acknowledgementSent = true;
                      console.log(response);

                      $scope.allAcknowledged = _.all($scope.messageResponses, function (mr) {
                        return !_.isNull(mr.acknowledged_at);
                      });
                      $scope.$broadcast('sa:slideSwipeContainer:advancePage', 1);

                    }, function (response) {
                      console.log('error in response when sending acknowledgement');
                    });
              };

              $timeout(function() {
                $('.organization_message_embedded_link').on('mousedown', function(e) {
                  var omId = parseInt(_.last(e.target.classList).split('-')[1]);
                  var mr = _.find($scope.messageResponses, function(m) {
                    return m.organization_message.id === omId;
                  });
                  mr.$trackLink(e.target.href);
                });
              }, 300);
            }],
            resolve: {
              params: function () {
                return {
                  messageResponses: messageResponses
                };
              }
            }
          });
          modalInstance.result.then(function (result) {
                console.log('closed OrganizationMessageResponseModal');
                console.log(result);
                unreadMessagesModalOpen = false;
              },
              function (reason) {
                console.log('dismissed OrganizationMessageResponseModal with reason ' + reason);
              });
        }
      });



      var errorInitInterval = $interval(function() {
        if (window.Rollbar && !window.Rollbar.onload && ServerUrls.matchingServerHost()) {
          window.Rollbar.configure({payload: { environment: ServerUrls.getCurrentErrorEnv()}});
          window.Rollbar.configure({payload: { client_type: ClientTypeDetectionService.getBrowserCharacteristics()}});

          var matchingServer = ServerUrls.matchingServerHost();
          if (lodash.isUndefined(matchingServer) || matchingServer.name === 'development') {
            window.Rollbar.configure({enabled: false});
          }

          $interval.cancel(errorInitInterval);
        }
      }, 100);


    $timeout(function() {
      console.log('accessTokenCheck ran');
      if (Session.getAccessToken() === 'undefined') {
        console.log('accessToken was undefined');
        // window.Rollbar.error('AccessToken at run was undefined as string', {
        //   sa_accessToken: Session.getAccessToken(),
        //   sa_refreshToken: Session.getRefreshToken(),
        //   sa_currentUserId: Session.getCurrentUserId(),
        //   sa_currentOrgId: Session.getCurrentOrgId()
        // });
        Session.logout();

      }

    }, 3000);

    $confirmModalDefaults.windowClass = 'modal-confirm';
    $confirmModalDefaults.template = '<div class="modal-header"><h3 class="modal-title">{{data.title}}</h3></div>' +
    '<div class="modal-body">{{data.text}}</div>' +
    '<div class="modal-footer">' +
    '<div class="options-container">' +
    '<button class="sa_button sa_medium sa_blue" ng-click="ok()">{{data.ok}}</button>' +
    '<button class="sa_button sa_medium sa_gray" ng-click="cancel()">{{data.cancel}}</button>' +
    '</div>' +
    '</div>';
    }]);
